
import {
    CALIBRATIONV3SCREEN_LOAD,
    CALIBRATIONV3SCREEN_UNLOAD,
    CALIBRATIONV3SCREEN_SET,
} from '../../../actionDefinitions';

import {
    fetchTeamsJibeStats,
    fetchTeamsJibedPercentageStats,
    fetchTeamAgentsJibeStats,
    fetchAgentJibeSummary,
    fetchAgentInteractions,
    fetchJibeProgressOverTimeStats,
    fetchAgentJibeProgressOverTimeStats,
    //To remove
    fetchProgressOverTimeStatsByTeam,
    _postJibeSession,
} from '../../../api/v3/CalibrationV3Api';

import {
    fetchCalibratedOnSurveyQuestions,
    fetchUserTeamsStats
} from '../../../api/v3/DataApi';

import moment from 'moment';
import 'moment-duration-format';
import { dateFormat, timePeriodicityOptions } from '../../../constants';

export function loadJibeManagerScreen() {
    return dispatch => {
        dispatch(loadCalibratedOnSurveyQuestions());
        dispatch(loadTeamsJibeStats());
        dispatch(loadTeamsJibedPercentageStats());
        dispatch(loadUserTeamsStats());
    };
}

export function loadJibeSupervisorScreen(fromDate, toDate, teamId) {
    return dispatch => {
        dispatch(loadCalibratedOnSurveyQuestions());
        dispatch(loadUserTeamsStats());
        dispatch(loadTeamAgentsJibeStats(teamId));
        dispatch(loadProgressOverTimeStats(fromDate, toDate, timePeriodicityOptions[0].value, teamId));

    };
}

export function loadJibeAgentScreen(userId, fromDate, toDate) {
    return dispatch => {
        dispatch(loadAgentJibeSummary(userId));
        dispatch(loadAgentJibeProgressOverTimeStats(userId, fromDate, toDate));
        dispatch(loadCalibratedOnSurveyQuestions());
        dispatch(loadAgentInteractions(userId, fromDate, toDate));
    };
}

export function loadProgressOverTimeStats(fromDate, toDate, timePeriodicity, teamId) {
    return dispatch =>
        fetchJibeProgressOverTimeStats(fromDate, toDate, timePeriodicity, teamId)
            .then(payload => dispatch({ type: CALIBRATIONV3SCREEN_LOAD, payload: { jibeProgressOverTimeStats: payload.result } }))
            .catch(payload => dispatch({ type: CALIBRATIONV3SCREEN_LOAD, error: true, payload }))
}

export function loadCalibratedOnSurveyQuestions() {
    return dispatch =>
        fetchCalibratedOnSurveyQuestions()
            .then(payload => dispatch({ type: CALIBRATIONV3SCREEN_LOAD, payload: { calibratedOnSurveyQuestions: payload.result } }))
            .catch(payload => dispatch({ type: CALIBRATIONV3SCREEN_LOAD, error: true, payload }))
}

export function loadTeamsJibeStats() {
    return dispatch =>
        fetchTeamsJibeStats()
            .then(payload => dispatch({ type: CALIBRATIONV3SCREEN_LOAD, payload: { teamsCalibrationStats: payload.result } }))
            .catch(payload => dispatch({ type: CALIBRATIONV3SCREEN_LOAD, error: true, payload }))
}

export function loadTeamsJibedPercentageStats() {
    return dispatch =>
        fetchTeamsJibedPercentageStats()
            .then(payload => dispatch({ type: CALIBRATIONV3SCREEN_LOAD, payload: { teamsJibedPercentageStats: payload.result } }))
            .catch(payload => dispatch({ type: CALIBRATIONV3SCREEN_LOAD, error: true, payload }))
}

export function loadTeamAgentsJibeStats(teamId) {
    return dispatch =>
        fetchTeamAgentsJibeStats(teamId)
            .then(payload => dispatch({ type: CALIBRATIONV3SCREEN_LOAD, payload: { currentTeamAgentsCalibrationStats: payload.result } }))
            .catch(payload => dispatch({ type: CALIBRATIONV3SCREEN_LOAD, error: true, payload }))
}

export function loadAgentJibeSummary(userId) {
    return dispatch =>
        fetchAgentJibeSummary(userId)
            .then(payload => dispatch({ type: CALIBRATIONV3SCREEN_LOAD, payload: { agentCalibrationSummary: payload.result } }))
            .catch(payload => dispatch({ type: CALIBRATIONV3SCREEN_LOAD, error: true, payload }))
}

export function loadAgentJibeProgressOverTimeStats(userId, fromDate, toDate) {
    return dispatch =>
        fetchAgentJibeProgressOverTimeStats(userId, fromDate, toDate)
            .then(payload => dispatch({ type: CALIBRATIONV3SCREEN_LOAD, payload: { agentJibeProgressOverTimeStats: payload.result } }))
            .catch(payload => dispatch({ type: CALIBRATIONV3SCREEN_LOAD, error: true, payload }))
}

export function loadAgentInteractions(userId, fromDate, toDate) {
    return dispatch =>
        fetchAgentInteractions(userId, moment(fromDate).subtract(90, 'd').format(dateFormat), toDate)
            .then(payload => dispatch({ type: CALIBRATIONV3SCREEN_LOAD, payload: { agentInteractions: payload.result } }))
            .catch(payload => dispatch({ type: CALIBRATIONV3SCREEN_LOAD, error: true, payload }))
}

export function loadUserTeamsStats() {
    return dispatch =>
        fetchUserTeamsStats()
            .then(payload => dispatch({ type: CALIBRATIONV3SCREEN_LOAD, payload: { userTeamsStats: payload.result } }))
            .catch(payload => dispatch({ type: CALIBRATIONV3SCREEN_LOAD, error: true, payload }))
}

export function postJibeSession(jibeSession) {
    return dispatch =>
        _postJibeSession(jibeSession)
            .then(payload => dispatch({ type: CALIBRATIONV3SCREEN_LOAD, payload: { jibeSessionIsDone: payload.result } }))
            .catch(payload => dispatch({ type: CALIBRATIONV3SCREEN_LOAD, error: true, payload }))
}

export function updateProps(updatedProps) {
    return dispatch => {
        return dispatch({ type: CALIBRATIONV3SCREEN_SET, updatedProps });
    }
}
